import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ComingSoonPage from './pages/ComingSoonPage';
import CheckoutPage from './pages/CheckoutPage';
import LearnMorePage from './pages/LearnMorePage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsPage from './pages/TermsPage';
import SecurityPage from './pages/SecurityPage';
import EnforcementActionsPage from './pages/EnforcementActionsPage';
import CompliancePage from './pages/CompliancePage';
import CookiesPage from './pages/CookiesPage';
import AccessibilityPage from './pages/AccessibilityPage';
import SitemapPage from './pages/SitemapPage';

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/coming-soon" element={<ComingSoonPage />} />
        <Route path="/checkout/:assessmentId" element={<CheckoutPage />} />
        <Route path="/learn-more" element={<LearnMorePage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/security" element={<SecurityPage />} />
        <Route path="/enforcement" element={<EnforcementActionsPage />} />
        <Route path="/compliance" element={<CompliancePage />} />
        <Route path="/cookies" element={<CookiesPage />} />
        <Route path="/accessibility" element={<AccessibilityPage />} />
        <Route path="/sitemap" element={<SitemapPage />} />
      </Routes>
    </Router>
  );
}